/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-nested-ternary */
// eslint-disable-next-line no-unneeded-ternary
/* eslint-disable complexity */
// Copyright (c) 2023 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import {
    containsPOBox,
    isValid
} from '../../services/validations';
import DuplicatePINPlate from '@deere/cps-it.warranty-model-factory/lib/duplicate-pin-plate';
import DuplicatePinFormValidation from '../../state/duplicate-pin-form-validation';
import FileAttachmentPanel from './file-attachment-panel-cloud';
import FormActions from './form-actions';
import {FormattedMessage} from 'react-intl';
import LabeledInput from '../../../../claim/shared/components/claim-fields/labeled-input';
import LabeledInputWithBlur from '../../../../claim/shared/components/claim-fields/labeled-input-with-blur';
import ResponsibleAccounts from '../../../../claim/shared/components/claim-fields/responsible-accounts';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildDate} from '../../../../shared/services/build-date';
import {buildDealer} from '../../../../shared/services/build-dealer';
import {findMatchingAccount} from '../../../../claim/shared/services/claim-shared-helper';
import {generateTemporaryObjectKey} from '../../../../shared/services/generate-temporary-object-key';
import {hasAccess} from '../../../../shared/services/security';

const poBoxErrorMessage = 'Shipping to PO Box is not allowed. Enter a different address.';

function handlePinBlur(pin) {

    this.actions.updateFormValidation('pin', pin);
    pin ? this.actions.readProductDetails(pin) : this.actions.resetProductDetails();

}

function handlePINChange(pin) {

    this.actions.updatePIN(pin);

}

function handleDateSubmmitedChange(date) {

    this.actions.updateDuplicatePinPlate('dateSubmmited', date);

}

function handleMachineModelBlur(machineModel) {

    this.actions.updateFormValidation('machineModel', machineModel);

}

function handleShippingIdBlur(shippingId) {

    this.actions.updateFormValidation('shippingId', shippingId);

}

function handleMachineModelChange(machineModel) {

    this.actions.updateMachineModel(machineModel);

}

function handleRequesterTCSMBlur(requesterTCSM) {

    this.actions.updateFormValidation('requesterTCSM', requesterTCSM);

}

function handleRequesterTCSMChange(requesterTCSM) {

    this.actions.updateRequesterTSCM(requesterTCSM);

}

function handleMissingPlateReasonBlur(missingPlateReason) {

    this.actions.updateFormValidation('missingPlateReason', missingPlateReason);

}

function handleMissingPlateReasonChange(missingPlateReason) {

    this.actions.updateMissingPlateReason(missingPlateReason);

}

function handleDealerLocationBlur(dealer) {

    this.actions.updateFormValidation('dealer', dealer);

}

function handleDealerLocationInputChange(account) {

    this.actions.updateDealerLocation(account.toUpperCase());

}

function handleResponsibleAccountBlur(dealer) {

    this.actions.updateFormValidation('dealer', dealer);

}

function handleDealerLocationDropdownChange(account) {

    const responsibleDealer = findMatchingAccount(account, this.user.settings.dealer.accounts.registrationAllowedAccounts);

    this.actions.updateDuplicatePinPlate('dealer', responsibleDealer);

}

function handleMailingRecipientBlur(mailingRecipient) {

    this.actions.updateFormValidation('mailingRecipient', mailingRecipient);

}

function handleMailingRecipientChange(mailingRecipient) {

    this.actions.updateMailingRecipient(mailingRecipient);

}

function handleAddressLine1Blur(address1) {

    this.actions.updateFormValidation('address1', address1, this.duplicatePinPlate);

}

function handleAddressLine1Change(address1) {

    this.actions.updateAddressLine1(address1);

}

function handleAddressLine2Change(address2) {

    this.actions.updateAddressLine2(address2);

}

function handleAddressLine2Blur(address2) {

    this.actions.updateAddressLine2(address2);

}

function handleCityBlur(city) {

    this.actions.updateFormValidation('city', city);

}

function handleCityChange(city) {

    this.actions.updateCity(city);

}

function handleZipCodeBlur(postalCode) {

    this.actions.updateFormValidation('zipCode', postalCode);

}

function handleZipCodeChange(postalCode) {

    this.actions.updateZipCode(postalCode);

}

function handleStateBlur(state) {

    this.actions.updateFormValidation('state', state);

}

function handleStateChange(state) {

    this.actions.updateState(state);

}

function handleCountryBlur(country) {

    this.actions.updateFormValidation('country', country);

}

function handleCountryChange(country) {

    this.actions.updateCountry(country);

}

function handlePhoneBlur(phone) {

    this.actions.updateFormValidation('phone', phone);

}

function handlePhoneChange(phone) {

    this.actions.updatePhone(phone);

}

function handleInstructionsChange(instruction) {

    this.actions.updateInstructions(instruction);

}

function handleFileDelete(file) {

    this.actions.deleteFile(file);

}

function handleFileUploadSuccess(file, dropzone) {

    this.actions.addFile(JSON.parse(file.xhr.response));
    dropzone.removeFile(file);

}

function handleDuplicatePinPlateSubmit() {

    this.actions.handleDuplicatePinPlateSubmit(this.duplicatePinPlate);

}

function handleDuplicatePinPlateUpdate() {

    this.actions.handleDuplicatePinPlateUpdate(this.duplicatePinPlate);

}

function handleDuplicatePinPlateCancle() {

    this.actions.resetDuplicatePinPlate();
    this.actions.updateDuplicatePinPlate('dateSubmmited', Date.now());

}

function handleDuplicatePinPlateInProcess() {

    this.actions.handleDuplicatePinPlateInProcess(this.duplicatePinPlate);

}

function handleShippingId(shippingId) {

    this.actions.updateDuplicatePinPlate('shippingId', shippingId);

}

const isEditDuplicatePinPlateEditable = duplicatePinPlate =>
duplicatePinPlate.status === '' ? true : duplicatePinPlate.status !== '' && (duplicatePinPlate.status === 'SUBMITTED' || duplicatePinPlate.status === 'PENDING') ? true : false;

const isEditDuplicatePinPlate = duplicatePinPlate =>
 duplicatePinPlate.status === '' ? true : false;

class Form extends Component {

    state = {
        clickEditButton: false
    };

    componentWillMount() {

        this.props.actions.updateDuplicatePinPlate('dateSubmmited', Date.now());
        this.props.actions.updateTemporaryObjectKey(generateTemporaryObjectKey());

    }

    componentWillUnmount() {

        this.props.actions.resetDuplicatePinPlate();

    }

    render() {

        const isAddressLine1POBox = containsPOBox(this.props.duplicatePinPlate.dealer.location.address1);
        const isAddressLine2POBox = containsPOBox(this.props.duplicatePinPlate.dealer.location.address2);
        const isAddressLine1Valid = this.props.formValidation.address1 && !isAddressLine1POBox;
        const isAddressLine2Valid = !isAddressLine2POBox;

        return (
            <section className='duplicate-pin-plate-form'>
                <span className='title'>
                    <FormattedMessage id='PLATE_REQUEST_INFORMATION'/>
                </span>
                <div className='row-one'>
                    <LabeledInputWithBlur
                        className={`pin required ${this.props.formValidation.pin ? '' : 'error'}`}
                        errorMessage='PIN_REQUIRED'
                        isEditable={isEditDuplicatePinPlate(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.pin}
                        label='PIN'
                        maxLength={25}
                        onBlur={this.props::handlePinBlur}
                        onChange={this.props::handlePINChange}
                        tabIndex='1'
                        value={this.props.duplicatePinPlate.pin}
                    />
                    <LabeledInput
                        className='pin'
                        isEditable={false}
                        isValid={this.props.formValidation.dateSubmmited}
                        label='DATE_SUBMITTED'
                        onChange={this.props::handleDateSubmmitedChange}
                        placeholderText={this.props.user.getDateFormatValue()}
                        tabIndex='2'
                        value={buildDate(this.props.duplicatePinPlate.dateSubmmited)}
                    />
                    <FormActions
                        handleCancle={this.props::handleDuplicatePinPlateCancle}
                        handleInprocess={this.props::handleDuplicatePinPlateInProcess}
                        handleSubmit={this.props::handleDuplicatePinPlateSubmit}
                        handleUpdate={this.props::handleDuplicatePinPlateUpdate}
                        isDisabled={(this.props.duplicatePinPlate.status !== '') || !isValid(this.props.duplicatePinPlate, this.props.isValid, this.props.security)}
                        isUpdateDisabled={(this.props.duplicatePinPlate.status !== 'SUBMITTED' && this.props.duplicatePinPlate.status !== 'PENDING' && this.props.duplicatePinPlate.status !== 'INPROCESS') || !isValid(this.props.duplicatePinPlate, this.props.isValid, this.props.security)}
                        security={this.props.security}
                        status={this.props.duplicatePinPlate.status}
                        user={this.props.user}
                    />
                </div>
                <div className='row-two'>

                    <LabeledInputWithBlur
                        className={`machine-model required ${this.props.formValidation.machineModel ? '' : 'error'}`}
                        errorMessage='MACHINE_MODEL_TYPE_REQUIRED'
                        isEditable={isEditDuplicatePinPlate(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.machineModel}
                        label='MACHINE_MODEL_TYPE'
                        maxLength={18}
                        onBlur={this.props::handleMachineModelBlur}
                        onChange={this.props::handleMachineModelChange}
                        tabIndex='3'
                        value={this.props.duplicatePinPlate.machineModel}
                    />
                    <LabeledInputWithBlur
                        className={`requester-TCSM required ${this.props.formValidation.requesterTCSM ? '' : 'error'}`}
                        errorMessage='REQUESTER_TCSM_REQUIRED'
                        isEditable={isEditDuplicatePinPlate(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.requesterTCSM}
                        label='REQUESTER_TCSM'
                        maxLength={20}
                        onBlur={this.props::handleRequesterTCSMBlur}
                        onChange={this.props::handleRequesterTCSMChange}
                        tabIndex='4'
                        value={this.props.duplicatePinPlate.requesterTCSM}
                    />
                    <LabeledInputWithBlur
                        className={`reason-missing-plate required ${this.props.formValidation.missingPlateReason ? '' : 'error'}`}
                        errorMessage='REASON_FOR_MISSING_PLATE_REQUIRED'
                        isEditable={isEditDuplicatePinPlate(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.missingPlateReason}
                        label='REASON_FOR_MISSING_PLATE'
                        maxLength={50}
                        onBlur={this.props::handleMissingPlateReasonBlur}
                        onChange={this.props::handleMissingPlateReasonChange}
                        tabIndex='5'
                        value={this.props.duplicatePinPlate.missingPlateReason}
                    />
                </div>
                <hr/>
                <span className='shipping'>
                    <FormattedMessage id='SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS'/>
                </span>
                <div className='row-three'>
                    {hasAccess(this.props.security, 'PRT', 'PRT_DUPLICATE_PIN_INTERNAL') ?
                        <LabeledInputWithBlur
                            className={`dealer required ${this.props.formValidation.dealer ? '' : 'error'}`}
                            errorMessage='ACCOUNT_NUMBER_REQUIRED'
                            isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                            isValid={this.props.formValidation.dealer}
                            label='DEALER_LOCATION'
                            maxLength={30}
                            onBlur={this.props::handleDealerLocationBlur}
                            onChange={this.props::handleDealerLocationInputChange}
                            tabIndex='6'
                            value={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate) ? this.props.duplicatePinPlate.dealer.account : buildDealer(this.props.duplicatePinPlate.dealer)}
                        /> : <ResponsibleAccounts
                            dealers={this.props.user.settings.dealer.accounts.registrationAllowedAccounts}
                            errorMessage='ACCOUNT_NUMBER_REQUIRED'
                            highlightClass={`required ${this.props.formValidation.dealer ? '' : 'error'}`}
                            isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                            isValid={this.props.formValidation.dealer}
                            onOptionBlur={this.props::handleResponsibleAccountBlur}
                            onOptionChange={this.props::handleDealerLocationDropdownChange}
                            selectedAccount={this.props.duplicatePinPlate.dealer}
                            tabIndex='6'
                             />
            }
                    <LabeledInputWithBlur
                        className={`mailing-recipient required ${this.props.formValidation.mailingRecipient ? '' : 'error'}`}
                        errorMessage='MAILING_RECIPIENT_REQUIRED'
                        isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.mailingRecipient}
                        label='MAILING_RECIPIENT'
                        maxLength={30}
                        onBlur={this.props::handleMailingRecipientBlur}
                        onChange={this.props::handleMailingRecipientChange}
                        tabIndex='7'
                        value={this.props.duplicatePinPlate.mailingRecipient}
                    />
                </div>
                <div className='row-four'>
                    <LabeledInputWithBlur
                        className={`address-line1 required ${isAddressLine1Valid ? '' : 'error'}`}
                        errorMessage={isAddressLine1POBox ? poBoxErrorMessage : 'ADDRESS_LINE1_REQUIRED'}
                        isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                        isValid={isAddressLine1Valid}
                        label='ADDRESS_LINE1'
                        maxLength={50}
                        onBlur={this.props::handleAddressLine1Blur}
                        onChange={this.props::handleAddressLine1Change}
                        tabIndex='6'
                        value={this.props.duplicatePinPlate.dealer.location.address1}
                    />
                    <LabeledInputWithBlur
                        className={`address-line2 ${isAddressLine2Valid ? '' : 'error'}`}
                        errorMessage={poBoxErrorMessage}
                        isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                        isValid={isAddressLine2Valid}
                        label='ADDRESS_LINE2'
                        maxLength={50}
                        onBlur={this.props::handleAddressLine2Blur}
                        onChange={this.props::handleAddressLine2Change}
                        tabIndex='7'
                        value={this.props.duplicatePinPlate.dealer.location.address2 || ''}
                    />
                </div>
                <div className='row-five'>
                    <LabeledInputWithBlur
                        className={`city required ${this.props.formValidation.city ? '' : 'error'}`}
                        errorMessage='CITY_REQUIRED'
                        isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.city}
                        label='CITY'
                        maxLength={18}
                        onBlur={this.props::handleCityBlur}
                        onChange={this.props::handleCityChange}
                        tabIndex='8'
                        value={this.props.duplicatePinPlate.dealer.location.city}
                    />
                    <LabeledInputWithBlur
                        className={`zip-code required ${this.props.formValidation.zipCode ? '' : 'error'}`}
                        errorMessage='POSTAL_CODE_REQUIRED'
                        isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.zipCode}
                        label='POSTAL_CODE'
                        maxLength={15}
                        onBlur={this.props::handleZipCodeBlur}
                        onChange={this.props::handleZipCodeChange}
                        tabIndex='9'
                        value={this.props.duplicatePinPlate.dealer.location.postalCode}
                    />
                    <LabeledInputWithBlur
                        className={`state required ${this.props.formValidation.state ? '' : 'error'}`}
                        errorMessage='STATE_PROVINCE_REQUIRED'
                        isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.state}
                        label='STATE_PROVINCE'
                        maxLength={18}
                        onBlur={this.props::handleStateBlur}
                        onChange={this.props::handleStateChange}
                        tabIndex='10'
                        value={this.props.duplicatePinPlate.dealer.location.state}
                    />
                </div>
                <div className='row-six'>
                    <LabeledInputWithBlur
                        className={`country required ${this.props.formValidation.country ? '' : 'error'}`}
                        errorMessage='COUNTRY_REQUIRED'
                        isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.country}
                        label='COUNTRY'
                        maxLength={18}
                        onBlur={this.props::handleCountryBlur}
                        onChange={this.props::handleCountryChange}
                        tabIndex='11'
                        value={this.props.duplicatePinPlate.dealer.location.country}
                    />
                    <LabeledInputWithBlur
                        className={`phone required ${this.props.formValidation.phone ? '' : 'error'}`}
                        errorMessage='PHONE_REQUIRED'
                        isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                        isValid={this.props.formValidation.phone}
                        label='PHONE'
                        maxLength={15}
                        onBlur={this.props::handlePhoneBlur}
                        onChange={this.props::handlePhoneChange}
                        tabIndex='12'
                        value={this.props.duplicatePinPlate.dealer.phone}
                    />
                    <LabeledInput
                        className='instructions'
                        isEditable={isEditDuplicatePinPlateEditable(this.props.duplicatePinPlate)}
                        label='SPECIAL_INSTRUCTIONS'
                        maxLength={100}
                        onChange={this.props::handleInstructionsChange}
                        tabIndex='13'
                        value={this.props.duplicatePinPlate.instruction}
                    />
                </div>
                <div className='row-seven'>
                    {hasAccess(this.props.security, 'PRT', 'PRT_FACTORY_USER_PIN_PLATE') && this.props.duplicatePinPlate.status === 'INPROCESS' ?
                        <LabeledInputWithBlur
                            className={`shippingId required ${this.props.formValidation.shippingId ? '' : 'error'}`}
                            errorMessage='SHIPPING_ID_REQUIRED'
                            isEditable={true}
                            isValid={this.props.formValidation.shippingId}
                            label='SHIPPING_ID'
                            maxLength={30}
                            onBlur={this.props::handleShippingIdBlur}
                            onChange={this.props::handleShippingId}
                            tabIndex='14'
                            value={this.props.duplicatePinPlate.shippingId}
                        /> : null
            }
                </div>
                {this.props.duplicatePinPlate.status === '' || this.props.duplicatePinPlate.status === 'SUBMITTED' || this.props.duplicatePinPlate.status === 'PENDING' ? (
                    <FileAttachmentPanel
                        files={this.props.duplicatePinPlate.file}
                        onFileDelete={this.props::handleFileDelete}
                        onFileUploadSuccess={this.props::handleFileUploadSuccess}
                        serviceConfig={{
                            className: 'BUS2222',
                            classType: 'OT',
                            objectKey: this.props.duplicatePinPlate.file[0] ? this.props.duplicatePinPlate.file[0].objectKey : this.props.temporaryObjectKey
                        }}
                    />
                ) : null}
            </section>
        );

    }
}

Form.displayName = 'Form';
Form.propTypes = {
    actions: PropTypes.object.isRequired,
    duplicatePinPlate: PropTypes.instanceOf(DuplicatePINPlate).isRequired,
    formValidation: PropTypes.instanceOf(DuplicatePinFormValidation).isRequired,
    isValid: PropTypes.bool.isRequired,
    security: PropTypes.instanceOf(Security).isRequired,
    temporaryObjectKey: PropTypes.string,
    user: PropTypes.instanceOf(User).isRequired
};

export default Form;



// WEBPACK FOOTER //
// ./src/product/duplicate-pin-plate/components/duplicate-pin-plate-form/pin-plate-form.js